window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductItem', {
            name: 'Custom Product Item',
            enabled: true,
            apply: () => ({
              afterRender(element) {
               
                try {
                  // Start customization--------------------------------------------
                  let data = element.getParams().props.product;
                  console.log(data.title);
                  console.log(data);

                  var itemContainer = element.getRootElm();
                  var gridContainer = itemContainer.childNodes[0];

                  var linkContainer = itemContainer.childNodes[1];
                  var infoContainer = linkContainer.childNodes[0];

                  
                  
                  // Append the Meta Data
                  var hasMetaData = infoContainer.getElementsByClassName('custom-meta');
                  if (hasMetaData.length == 0) {
                    var metaText = '';
                    data.metafields.forEach(item => {
                        metaText = metaText + item.key.toUpperCase() + ': ' + item.value + ' ';          
                    });
                    const metaDataDiv = document.createElement("div");
                    metaDataDiv.setAttribute("class", "custom-meta")
                    const metaData = document.createTextNode(metaText);
                    metaDataDiv.appendChild(metaData);
  
                    infoContainer.appendChild(metaDataDiv);        
                  }

                  // Append the SKU
                  var hasSku = infoContainer.getElementsByClassName('custom-sku');
                  if (hasSku.length == 0) {
                    var skuText = 'SKU #' + data.skus[0];
                    const skuDiv = document.createElement("div");
                    skuDiv.setAttribute("class", "custom-sku")
                    const skuData = document.createTextNode(skuText);
                    skuDiv.appendChild(skuData);
  
                    infoContainer.insertBefore(skuDiv, infoContainer.firstChild);        
                  }

                  // Add the vendor logo
                  var hasVendorImage = gridContainer.getElementsByClassName('custom-vendor-image');
                  if (hasVendorImage.length == 0) {
                    var vendor = data.vendor.toLowerCase();
            		vendor = vendor.replace(/ /g, '-')
                    
                    const newImage = document.createElement("img");
                    newImage.setAttribute("src", "https://www.sailexchange.com.au/cdn/shop/files/" + vendor + ".png")
                    newImage.setAttribute("class", "custom-vendor-image")

                    gridContainer.insertBefore(newImage, gridContainer.firstChild);        
                  }

                } catch (e) {
                  console.error(e);
                }
              }
            })
        });
    }
]);
